import React from 'react'
import {useEffect, useState} from 'react'
import Button from '../Button'
import envVariables from '../../data/envVariables'
import PortalClosedLostModal from './PortalClosedLostModal'
import Modal from '../Modal'
import PortalNextStageCTA from './PortalNextStageCTA'
import PortalKycHeatIndicator from './PortalKycHeatIndicator'
import {formatDateAsDaysAgo} from '../../utilities/daysFromDate'
import format from "date-fns/format"


const PortalDetailsHeader = ({deal}) => {
    const [closedLostShy, setClosedLostShy] = useState(false)
    const [closedLostClient, setClosedLostClient] = useState(false)

    const updatedDate = new Date(deal.modified_Time)

    const onClosedLostShy = () => {
        setClosedLostShy(true)
    }

    const onClosedLostClient = () => {
        setClosedLostClient(true)
    }
    
    return (
        <>
            <div className={'portal__deal_details_header'}>
                <div className={'deal_details_header-desktop'}>
                    <div className={'deal_details_header__ctas'}>
                        <PortalNextStageCTA deal={deal} />
                        <Button classNames={['button button--secondary']} onClick={onClosedLostShy}>Closed/Lost (Shy)</Button>
                        <Button classNames={['button button--secondary']} onClick={onClosedLostClient}>Closed/Lost (client)</Button>
                    </div>
                    <div className={'gold_divider'}></div>
                </div>
                {deal && 
                <>
                <div className={'deal_card_header'}>
                    <div className={'deal_card_timestamp'}>Updated {formatDateAsDaysAgo(updatedDate)}</div>
                    <div className={'deal_card_kyc'}>
                        {deal.kyC_Heat && <PortalKycHeatIndicator kycHeat={deal.kyC_Heat} />}
                    </div>
                </div>
                <div className={'deal_card_tripName'}>
                    <h2>{deal.deal_Name}</h2>
                </div>
                <div className={'gold_divider'}></div>
                <div>
                    <label>Lead name:</label> {deal.leadFullName.trim().length ? deal.leadFullName : deal.contactFullName}
                </div>
                <div>
                    <label>Deal owner:</label> {deal.ownerFullName}
                </div>
                <div>
                    <label>Deal stage:</label> {deal.stage}
                </div>
                </>
                }

                {deal.legs && <div>
                    <strong>Route</strong>
                    {deal.legs.sort((a, b) => {return a.legNumber < b.legNumber ? -1 : 1}).map((leg, index) => {
                        const formatDate = format(new Date(leg.legDate), "dd/MM/yyyy", { awareOfUnicodeTokens: true })
                        
                        return (<p key={index}>
                            Leg: {leg.legNumber}: {leg.legFrom} - {leg.legTo}<br/>
                            <em>{formatDate} {leg.legTime}</em>
                        </p>
                        )
                    })}
                </div>}

                <div className={'gold_divider'}></div>

                <div className={'deal_details_subdetails'}>
                    {deal.avinodeTripId && 
                    <div>
                        Trip Id: {deal.avinodeTripId}
                    </div>
                    }
                    {deal.quoteStats && 
                        <>
                            <p>Accepted: {deal.quoteStats.accepted}</p>
                            <p>Declined: {deal.quoteStats.declined}</p>
                            <p>Unanswered: {deal.quoteStats.unanswered}</p>
                        </>
                    }
                </div>
                
                <div className={'deal_details_header-mobile'}>
                    <div className={'deal_details_header__ctas'}>
                        <PortalNextStageCTA deal={deal} />
                        <Button classNames={['button button--secondary']} onClick={onClosedLostShy}>Closed/Lost (Shy)</Button>
                        <Button classNames={['button button--secondary']} onClick={onClosedLostClient}>Closed/Lost (client)</Button>
                    </div>
                </div>
            </div>

            <Modal
                classNames={['modal__content--thin']}
                modalVisible={closedLostShy}
                closeModal={() => setClosedLostShy(false)}
            >
                <PortalClosedLostModal closeModal={() => setClosedLostShy(false)} closedBy={'shy'} dealId={deal.id} />
            </Modal>

            <Modal
                classNames={['modal__content--thin']}
                modalVisible={closedLostClient}
                closeModal={() => setClosedLostClient(false)}
            >
                <PortalClosedLostModal closeModal={() => setClosedLostClient(false)} closedBy={'client'} dealId={deal.id} />
            </Modal>
        </>
    )
}

export default PortalDetailsHeader